import { apiPost } from "./client";

export function postItfmaLogging(username, data) {
  return apiPost(`/itfma_logging/${username}/`, data);
}
